import React, { useState, useEffect } from "react";
import EventPairingsDefault from "./EventPairings/EventPairingsDefault";
import { useTranslation } from "react-i18next";
import { postNotification } from "../../../components/utilities/Notifications";
import { handlePagingAll } from "../../../components/api/APIUtilities";
import { userDisplayName } from "./EventFunctions";
import {
  delay,
  findGetParameter,
  getData,
  getIntegerFromString,
  newPath
} from "../../../components/utilities/UtilityFunctions";
import { useNavigate } from "react-router";
import { useConfirm } from "material-ui-confirm";

export function getCurrentRound(_event) {
  if (_event?.status?.currentRound !== undefined) {
    return _event?.status?.currentRound;
  }
  if (_event?.currentRound !== undefined) {
    return _event?.currentRound;
  }
  return 0;
}

export default function EventPairings(props) {
  const { t } = useTranslation();
  const {
    activeTab,
    handleTabChange,
    event,
    setEvent,
    organize,
    authContext,
    setResetModalOpen
  } = props;

  const [refreshPairings, setRefreshPairings] = useState(false);
  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(true);
  const [roundNo, setRoundNo] = useState(null);

  const [pairings, setPairings] = useState(null);
  const [teamPairings, setTeamPairings] = useState(null);
  const [seatedPairings, setSeatedPairings] = useState(null);

  const [timerData, setTimerData] = useState(null);

  const [triggerHandlePairingStatus, setTriggerHandlePairingStatus] =
    useState(false);
  const [pairingStatus, setPairingStatus] = useState(null);
  const [pairingProgress, setPairingProgress] = useState(0);

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);

  const [pairingPopUp, setPairingPopUp] = useState(null);
  const [optionsAnchorEl4, setOptionsAnchorEl4] = useState(null);
  const [optionsAnchorEl5, setOptionsAnchorEl5] = useState(null);
  const [optionsAnchorEl6, setOptionsAnchorEl6] = useState(null);

  const [optionsAnchorEl2, setOptionsAnchorEl2] = useState(null);
  const [pairing, setPairing] = useState(null);
  const [teamPairing, setTeamPairing] = useState(null);
  const [seatedPairing, setSeatedPairing] = useState(null);
  const [, setSoftScorePairings] = useState(null);

  const [player, setPlayer] = useState(null);
  const [teamPlayer, setTeamPlayer] = useState(null);

  const [betweenRoundsModal, setBetweenRoundsModal] = useState(false);

  const [players, setPlayers] = useState(null);
  const [teamPlayers, setTeamPlayers] = useState(null);

  const [armyModalOpen, setArmyModalOpen] = useState(false);
  const [swapPlayerModal, setSwapPlayerModal] = useState(false);
  const [swapTeamModal, setSwapTeamModal] = useState(false);
  const [swapSeatedPairingModal, setSwapSeatedPairingModal] = useState(false);
  const [swapSeatNumberModal, setSwapSeatNumberModal] = useState(false);

  const [swapTableModal, setSwapTableModal] = useState(false);

  const [createPairingModal, setCreatePairingModal] = useState(false);

  const [roundTimerOptions, setRoundTimerOptions] = useState(null);
  const [topCutOptions, setTopCutOptions] = useState(null);
  const [endEventModal, setEndEventModal] = useState(false);

  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  const [filteredPairings, setFilteredPairings] = useState(null);
  const [filterType, setFilterType] = useState("");

  // Used to add a slight delay before fetching round data when switching between multiple rounds
  const [_roundNo, set_RoundNo] = useState(roundNo);
  const [timer, setTimer] = useState(null);

  // const [placingsReady, setPlacingsReady] = useState(
  //   event?.ended || event?.currentRound !== roundNo ? true : false
  // );

  const navigate = useNavigate();
  const confirm = useConfirm();

  // Checks if placings are up to date
  // const checkStatus = async () => {
  //   if (event && (!event?.ended || event?.currentRound === roundNo)) {
  //     try {
  //       const apiStatus = await getData(`/events/${event.id}/updatestatus`);
  //       if (apiStatus?.status === "ready") {
  //         setPlacingsReady(true);
  //       }
  //       if (apiStatus?.status === "processing") {
  //         setPlacingsReady(false);
  //       }
  //     } catch (err) {
  //       setPlacingsReady(false);
  //     }
  //   }
  // };

  const fetchSoftScorePairings = async (round) => {
    if (round === 0) return [];

    var returnArray = [];

    try {
      returnArray = await handlePagingAll("/pairings", {
        limit: 500,
        eventId: event.id,
        round: round,
        pairingType: "SoftScorePairing",
        "expand[]": ["player", "teamPlayer"]
      });
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchPairings = async (round) => {
    if (round === 0) return [];

    var returnArray = [];

    try {
      const apiPairings = await getData(`/events/${event?.id}/pairings`, {
        round: round,
        pairingType: "Pairing"
      });

      if (apiPairings?.active?.length) returnArray = apiPairings?.active;

      if (returnArray?.length) {
        if (!event?.teamEvent || event?.doublesEvent) {
          var newPods = {};
          var hasPods = false;
          returnArray.forEach((p) => {
            if (
              (p.podNum === undefined && !newPods["undefined"]) ||
              !newPods[p.podNum]
            ) {
              newPods[p.podNum !== undefined ? p.podNum : "undefined"] = {
                isPod: true,
                podNum: p.podNum
              };
              if (!hasPods && p.podNum !== undefined) hasPods = true;
            }
          });
          handlePodLabels(newPods);
          if (hasPods) returnArray.push(...Object.values(newPods));
        }

        returnArray.sort((a, b) => {
          if (a?.podNum && !b?.podNum) return -1;
          if (!a?.podNum && b?.podNum) return 1;
          if (a?.podNum < b?.podNum) return -1;
          if (a?.podNum > b?.podNum) return 1;
          if (a?.isPod && !b?.isPod) return -1;
          if (!a?.isPod && b?.isPod) return 1;
          if (a?.table !== undefined && a?.table === undefined) return -1;
          if (a?.table === undefined && a?.table !== undefined) return 1;

          return a?.table - b?.table;
        });
      }
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchSeatedPairings = async (round) => {
    if (round === 0) return [];

    var returnArray = [];
    try {
      const apiPairings = await getData(`/events/${event?.id}/pairings`, {
        round: round,
        pairingType: "SeatedPairing"
      });
      if (apiPairings?.active?.length) {
        returnArray = apiPairings.active;
      }
      if (returnArray?.length) {
        if (!event?.teamEvent || event?.doublesEvent) {
          var newPods = {};
          var hasPods = false;
          returnArray.forEach((p) => {
            if (
              (p.podNum === undefined && !newPods["undefined"]) ||
              !newPods[p.podNum]
            ) {
              newPods[p.podNum !== undefined ? p.podNum : "undefined"] = {
                isPod: true,
                podNum: p.podNum
              };
              if (!hasPods && p.podNum !== undefined) hasPods = true;
            }
          });
          handlePodLabels(newPods);
          if (hasPods) returnArray.push(...Object.values(newPods));
        }

        returnArray.sort((a, b) => {
          if (a.podNum && !b.podNum) return -1;
          if (!a.podNum && b.podNum) return 1;
          if (a.podNum < b.podNum) return -1;
          if (a.podNum > b.podNum) return 1;
          if (a.isPod && !b.isPod) return -1;
          if (!a.isPod && b.isPod) return 1;
          if (a.table !== undefined && a.table === undefined) return -1;
          if (a.table === undefined && a.table !== undefined) return 1;

          return a.table - b.table;
        });
      }
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchPlayers = async () => {
    if (!(organize || event?.boardGameEvent) && !event?.doublesEvent) return [];
    if (event?.id === "7CA6VVLL6P") return [];
    const returnArray = [];
    try {
      const apiPlayers = await getData(`/events/${event?.id}/players`);

      if (apiPlayers && apiPlayers?.active?.length) {
        returnArray.push(...apiPlayers.active);
      }

      if (!returnArray || !returnArray?.length) {
        return [];
      }
    } catch (err) {
      console.error(err);
      return [];
    }
    return returnArray?.filter((el) => el?.checkedIn);
  };

  const fetchTeamPlayers = async () => {
    if (!organize) return [];
    if (event?.id === "7CA6VVLL6P") return [];
    var returnArray = [];
    try {
      const apiTeamPlayers = await getData(`/events/${event?.id}/teamPlayers`, {
        placings: false
      });
      if (apiTeamPlayers?.active?.length) {
        returnArray = apiTeamPlayers.active;
      }
    } catch (err) {
      console.log(err);
      return undefined;
    }
    return returnArray;
  };

  const fetchTeamPairings = async (round) => {
    if (round === 0) return [];
    var returnArray = [];

    try {
      const apiPairings = await getData(`/events/${event?.id}/pairings`, {
        round: round,
        pairingType: "TeamPairing"
      });
      if (apiPairings?.active?.length) {
        returnArray = apiPairings.active;
      }
      if (returnArray?.length) {
        var newPods = {};
        var hasPods = false;
        returnArray.forEach((p) => {
          if (
            (p.podNum === undefined && !newPods["undefined"]) ||
            !newPods[p.podNum]
          ) {
            newPods[p.podNum !== undefined ? p.podNum : "undefined"] = {
              isPod: true,
              podNum: p.podNum
            };
            if (!hasPods && p.podNum !== undefined) hasPods = true;
          }
        });
        handlePodLabels(newPods);
        if (hasPods) returnArray.push(...Object.values(newPods));

        returnArray.sort((a, b) => {
          if (a.podNum && !b.podNum) return -1;
          if (!a.podNum && b.podNum) return 1;
          if (a.podNum < b.podNum) return -1;
          if (a.podNum > b.podNum) return 1;
          if (a.isPod && !b.isPod) return -1;
          if (!a.isPod && b.isPod) return 1;
          if (a.table !== undefined && a.table === undefined) return -1;
          if (a.table === undefined && a.table !== undefined) return 1;

          return a.table - b.table;
        });
      }
    } catch (err) {
      console.error(err);
      return undefined;
    }
    return returnArray;
  };

  async function parallel(round) {
    const taskPairings =
      !event?.boardGameEvent && !event?.doublesEvent
        ? fetchPairings(round)
        : [];
    const taskTeamPairings =
      !event?.boardGameEvent && event?.teamEvent
        ? fetchTeamPairings(round)
        : [];
    const taskSeatedPairings = event?.boardGameEvent
      ? fetchSeatedPairings(round)
      : [];
    const taskSoftScorePairings = organize ? fetchSoftScorePairings(round) : [];
    const taskPlayers = fetchPlayers();
    const taskTeamPlayers = event?.teamEvent ? fetchTeamPlayers() : [];

    return {
      pairings: await taskPairings,
      teamPairings: await taskTeamPairings,
      players: await taskPlayers,
      teamPlayers: await taskTeamPlayers,
      seatedPairings: await taskSeatedPairings,
      softScorePairings: await taskSoftScorePairings
    };
  }

  const handlePodLabels = (newPods) => {
    if (Object.keys(newPods)?.length > 0) {
      if (event.topCut) {
        if (newPods[1]) {
          newPods[1].label = event.doubleElimination
            ? "Championship Bracket"
            : "Top Cut";
        }
        if (event.doubleElimination) {
          if (newPods[2]) {
            newPods[2].label = "Elimination Bracket";
          }
          if (newPods[3]) {
            newPods[3].label = "Eliminated Bracket";
          }
        }
      } else if (
        event.pairingStyle === "single elimination" ||
        event.pairingStyle === "double elimination"
      ) {
        if (newPods[1]) {
          newPods[1].label = "Championship Bracket";
        }
        if (newPods[2]) {
          newPods[2].label =
            event.pairingStyle === "single elimination"
              ? "Eliminated Bracket"
              : "Elimination Bracket";
        }
        if (newPods[3]) {
          newPods[3].label = "Eliminated Bracket";
        }
      }
    }
  };

  const handlePairings = async (round) => {
    if (round === 0) {
      setPairings([]);
      setTeamPairings([]);
      setSeatedPairings([]);
      setSoftScorePairings([]);
      setSubLoading(false);
    }
    setSubLoading(true);
    try {
      var parallelData = await parallel(round);

      if (organize) {
        let softScores = event?.softScores?.filter(
          (el) => el.playerScored && el.roundByRound
        );
        if (softScores?.length) {
          // handle soft score stuff
          let tempSoftScoreDict = {};
          if (parallelData.softScorePairings?.length) {
            for (let softScorePairing of parallelData.softScorePairings) {
              if (!tempSoftScoreDict[softScorePairing.softScoreId]) {
                tempSoftScoreDict[softScorePairing.softScoreId] = {};
              }
              if (softScorePairing.parentPairingId) {
                if (
                  !tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ]
                ) {
                  tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ] = {};
                }
                if (softScorePairing.playerId) {
                  tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ][softScorePairing.playerId] = softScorePairing;
                } else if (softScorePairing.byePlayer) {
                  tempSoftScoreDict[softScorePairing.softScoreId][
                    softScorePairing.parentPairingId
                  ]["byePlayer"] = softScorePairing;
                }
              } else {
                // TODO: build others
              }
            }
          }

          // TODO: build non singles event logic
          for (let i = 0; i < parallelData.pairings?.length; i++) {
            for (let softScore of softScores) {
              if (!parallelData.pairings[i].player1SoftScores) {
                parallelData.pairings[i].player1SoftScores = [];
              }
              if (!parallelData.pairings[i].player2SoftScores) {
                parallelData.pairings[i].player2SoftScores = [];
              }

              if (parallelData.pairings[i].player1Id) {
                if (parallelData.pairings[i].player2Id) {
                  let softScorePairing = tempSoftScoreDict[softScore.id]?.[
                    parallelData.pairings[i].id
                  ]?.[parallelData.pairings[i].player1Id] || {
                    isDone: false
                  };
                  softScorePairing.softScore = softScore;
                  parallelData.pairings[i].player1SoftScores.push(
                    softScorePairing
                  );
                } else {
                  parallelData.pairings[i].player1SoftScores.push({
                    playerId: parallelData.pairings[i].player1Id,
                    isDone: true,
                    byeOpponent: true,
                    softScore: softScore
                  });
                }
              } else if (parallelData.pairings[i].player2Id) {
                let softScorePairing = tempSoftScoreDict[softScore.id]?.[
                  parallelData.pairings[i].id
                ]?.["byePlayer"] || {
                  isDone: false
                };
                softScorePairing.softScore = softScore;
                parallelData.pairings[i].player1SoftScores.push(
                  softScorePairing
                );
              }

              if (parallelData.pairings[i].player2Id) {
                if (parallelData.pairings[i].player1Id) {
                  let softScorePairing = tempSoftScoreDict[softScore.id]?.[
                    parallelData.pairings[i].id
                  ]?.[parallelData.pairings[i].player2Id] || {
                    isDone: false
                  };
                  softScorePairing.softScore = softScore;
                  parallelData.pairings[i].player2SoftScores.push(
                    softScorePairing
                  );
                } else {
                  // BYE
                  parallelData.pairings[i].player2SoftScores.push({
                    playerId: parallelData.pairings[i].player2Id,
                    isDone: true,
                    byeOpponent: true,
                    softScore: softScore
                  });
                }
              } else if (parallelData.pairings[i].player1Id) {
                let softScorePairing =
                  tempSoftScoreDict[softScore.id]?.[
                    parallelData.pairings[i].id
                  ]?.["byePlayer"] || {};
                softScorePairing.softScore = softScore;
                parallelData.pairings[i].player2SoftScores.push(
                  softScorePairing
                );
              }
            }
          }
        }
      }

      setPairings(parallelData.pairings);
      if (
        !organize &&
        event?.adepticonTeamEvent &&
        parallelData.teamPairings?.length
      ) {
        let teamPairingsDict = {};
        if (parallelData.pairings?.length) {
          parallelData.pairings.forEach((pairing) => {
            if (pairing.teamPairingId) {
              if (!teamPairingsDict[pairing.teamPairingId]) {
                teamPairingsDict[pairing.teamPairingId] = [];
              }
              teamPairingsDict[pairing.teamPairingId].push(pairing);
            }
          });
        }

        let playersDict = {};
        if (parallelData.players?.length) {
          parallelData.players.forEach((player) => {
            playersDict[player.id] = player;
          });
        }

        let teamPairingsMerged = {};
        parallelData.teamPairings.forEach((pairing) => {
          if (teamPairingsDict[pairing.id]) {
            pairing.pairings = teamPairingsDict[pairing.id];
          }
          if (
            pairing.teamPlayer1?.players?.length ||
            pairing.teamPlayer2?.players?.length
          ) {
            for (
              let i = 0;
              i < pairing.teamPlayer1?.players?.length ||
              i < pairing.teamPlayer2?.players?.length;
              i++
            ) {
              if (
                pairing.teamPlayer1?.players?.[i]?.objectId &&
                playersDict[pairing.teamPlayer1.players[i].objectId]
              ) {
                pairing.teamPlayer1.players[i] =
                  playersDict[pairing.teamPlayer1.players[i].objectId];
              }
              if (
                pairing.teamPlayer2?.players?.[i]?.objectId &&
                playersDict[pairing.teamPlayer2.players[i].objectId]
              ) {
                pairing.teamPlayer2.players[i] =
                  playersDict[pairing.teamPlayer2.players[i].objectId];
              }
            }
          }

          if (
            !teamPairingsMerged[
              `${pairing.teamPlayer1Id}-${pairing.teamPlayer2Id}`
            ]
          ) {
            teamPairingsMerged[
              `${pairing.teamPlayer1Id}-${pairing.teamPlayer2Id}`
            ] = pairing;
          } else {
            teamPairingsMerged[
              `${pairing.teamPlayer1Id}-${pairing.teamPlayer2Id}`
            ].secondaryTeamPairing = pairing;
          }
        });

        parallelData.teamPairings = Object.values(teamPairingsMerged);
        parallelData.teamPairings.sort((a, b) => {
          return (a?.table || 0) - (b?.table || 0);
        });
      } else if (parallelData.teamPairings?.length) {
        if (event?.doublesEvent) {
          // Adds missing player data for doubles events
          if (
            parallelData.players?.length &&
            parallelData.teamPairings?.length
          ) {
            parallelData.players.forEach((player) => {
              parallelData.teamPairings.forEach((pairing) => {
                if (player?.teamPlayerId === pairing?.teamPlayer1?.id) {
                  if (pairing?.teamPlayer1?.players?.length) {
                    pairing.teamPlayer1.players.push(player);
                  } else {
                    pairing.teamPlayer1.players = [player];
                  }
                }

                if (player?.teamPlayerId === pairing?.teamPlayer2?.id) {
                  if (pairing?.teamPlayer2?.players?.length) {
                    pairing.teamPlayer2.players.push(player);
                  } else {
                    pairing.teamPlayer2.players = [player];
                  }
                }
              });
            });
          }
        } else {
          let teamPairingsDict = {};
          if (parallelData.pairings?.length) {
            parallelData.pairings.forEach((pairing) => {
              if (pairing.teamPairingId) {
                if (!teamPairingsDict[pairing.teamPairingId]) {
                  teamPairingsDict[pairing.teamPairingId] = [];
                }
                teamPairingsDict[pairing.teamPairingId].push(pairing);
              }
            });
          }

          let playersDict = {};
          if (parallelData.players?.length) {
            parallelData.players.forEach((player) => {
              playersDict[player.id] = player;
            });
          }

          parallelData.teamPairings.forEach((pairing) => {
            if (teamPairingsDict[pairing.id]) {
              pairing.pairings = teamPairingsDict[pairing.id];
              if (event.adepticonTeamEvent) {
                pairing.pairings.sort((a, b) => {
                  return a?.primaryPairingId === a?.id ? -1 : 1;
                });
              }
            }
            if (
              pairing.teamPlayer1?.players?.length ||
              pairing.teamPlayer2?.players?.length
            ) {
              for (
                let i = 0;
                i < pairing.teamPlayer1?.players?.length ||
                i < pairing.teamPlayer2?.players?.length;
                i++
              ) {
                if (
                  pairing.teamPlayer1?.players?.[i]?.objectId &&
                  playersDict[pairing.teamPlayer1.players[i].objectId]
                ) {
                  pairing.teamPlayer1.players[i] =
                    playersDict[pairing.teamPlayer1.players[i].objectId];
                }
                if (
                  pairing.teamPlayer2?.players?.[i]?.objectId &&
                  playersDict[pairing.teamPlayer2.players[i].objectId]
                ) {
                  pairing.teamPlayer2.players[i] =
                    playersDict[pairing.teamPlayer2.players[i].objectId];
                }
              }
            }
          });
        }
      }

      var playersArray = [];
      if (parallelData?.players?.length) {
        parallelData.players.forEach((player) => {
          player.name = userDisplayName(
            player?.firstName || player?.user?.firstName,
            player?.lastName || player?.user?.lastName
          );
          parallelData.pairings.forEach((pairing) => {
            if (
              pairing?.player1?.id === player?.id ||
              pairing?.player2?.id === player.id
            ) {
              player.pairing = pairing;
            }
          });

          if (parallelData?.seatedPairings?.length) {
            parallelData.seatedPairings.forEach((pairing) => {
              pairing.seatedPlayers?.forEach((seatedPlayer, i) => {
                if (seatedPlayer?.playerId === player?.id) {
                  pairing.seatedPlayers[i] = {
                    ...seatedPlayer,
                    ...player?.user,
                    team: { ...player?.team },
                    table: pairing?.table
                  };
                }
              });
            });
          }
          playersArray.push(player);
        });
      } else {
        if (parallelData.pairings?.length) {
          parallelData.pairings.forEach((pairing) => {
            if (pairing.player1?.id) {
              pairing.player1.name = userDisplayName(
                pairing?.player1?.firstName ||
                  pairing?.player1?.user?.firstName,
                pairing?.player1?.lastName || pairing?.player1?.user?.lastName
              );
              playersArray.push(pairing.player1);
            }
            if (pairing.player2?.id) {
              pairing.player2.name = userDisplayName(
                pairing?.player2?.firstName ||
                  pairing?.player2?.user?.firstName,
                pairing?.player2?.lastName || pairing?.player2?.user?.lastName
              );
              playersArray.push(pairing?.player2);
            }
          });
        }
        if (parallelData.seatedPairings?.length) {
          parallelData.seatedPairings.forEach((pairing) => {
            if (pairing.seatedPlayers?.length) {
              for (let seatedPlayer of pairing.seatedPlayers) {
                if (seatedPlayer?.playerId) {
                  playersArray.push({
                    ...seatedPlayer,
                    name: seatedPlayer.playerName
                  });
                }
              }
            }
          });
        }
      }
      if (playersArray?.length) {
        playersArray.sort((a, b) => {
          var nameA = a?.name?.toLowerCase();
          var nameB = b?.name?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
      }

      setSeatedPairings(parallelData.seatedPairings);
      setTeamPairings(parallelData.teamPairings);
      setPlayers(playersArray);
      setSubLoading(false);
      if (parallelData.teamPairings?.length) {
        let teamPlayersArray = [];
        parallelData.teamPairings.forEach((pairing) => {
          if (pairing.teamPlayer1?.id) {
            teamPlayersArray.push(pairing.teamPlayer1);
          }
          if (pairing.teamPlayer2?.id) {
            teamPlayersArray.push(pairing.teamPlayer2);
          }
        });
        teamPlayersArray.sort((a, b) => {
          var nameA = a?.name?.toLowerCase();
          var nameB = b?.name?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
        setTeamPlayers(teamPlayersArray);
      }
    } catch (err) {
      console.error(err);
      postNotification("error", err);
    }
  };

  const handlePairingStatus = async (status, progress) => {
    if (status !== pairingStatus) setPairingStatus(status);
    if (status === "pending_generate") {
      await delay(1000);
      if (progress <= 90) {
        progress += 5;
        setPairingProgress(progress);
      }
      try {
        var apiGetData = await getData(`/events/${event.id}/pairingsStatus`);
        if (apiGetData.status)
          await handlePairingStatus(apiGetData.status, progress);
      } catch (err) {
        await handlePairingStatus(status, progress);
      }
    } else if (status === "active") {
      setPairingProgress(100);
      setPairingStatus(null);
      postNotification("success", t("notifications.success.pairingsGenerated"));
      setEvent({
        ...event,
        currentRound: getCurrentRound(event) + 1
      });
      changeRound(roundNo + 1);

      try {
        await confirm({
          title: `Set up Timer`,
          description: "Would you like to set up your round timer now?",
          dialogProps: {
            sx: {
              zIndex: 99999
            }
          },
          confirmationText: "Yes",
          cancellationText: "Later"
        });

        setRoundTimerOptions(event);
      } catch (err) {}
    } else if (status === "failed") {
      postNotification(
        "error",
        t("notifications.errors.errorGeneratingPairings")
      );
      setPairingProgress(0);
      setPairingStatus(null);
    }
  };

  // Used to add a slight delay before fetching round data when quickly switching between multiple rounds (1.5 seconds)
  const handleClick = (action) => {
    const interval = 1000;

    if (action === "inc") {
      if (_roundNo < getCurrentRound(event)) {
        set_RoundNo(_roundNo + 1);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo + 1);
            setSubLoading(false);
          }, interval)
        );
      } else if (_roundNo === getCurrentRound(event)) {
        set_RoundNo(roundNo);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo);
            setSubLoading(false);
          }, interval)
        );
      }
    } else {
      if (_roundNo > 1) {
        set_RoundNo(_roundNo - 1);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo - 1);
            setSubLoading(false);
          }, interval)
        );
      } else if (_roundNo === 1) {
        set_RoundNo(roundNo);
        setTimer(
          setTimeout(() => {
            changeRound(_roundNo);
            setSubLoading(false);
          }, interval)
        );
      }
    }

    // Reset the timer every time the button is clicked
    clearTimeout(timer);
  };

  const changeRound = (round) => {
    setSubLoading(true);

    var path = newPath({
      round: round
    });
    navigate(path, { replace: false });
    setRoundNo(round);
    set_RoundNo(round);
  };

  const postSoftScoreSubmit = (softScorePairing) => {
    if (organize) {
      let newPairings = pairings;
      let found = false;
      for (let i = 0; i < newPairings?.length; i++) {
        if (softScorePairing?.parentPairingId === newPairings[i].id) {
          for (let x = 0; x < newPairings[i].player1SoftScores?.length; x++) {
            if (
              newPairings[i].player1SoftScores[x].softScore?.id ===
              softScorePairing.softScoreId
            ) {
              if (
                (softScorePairing?.playerId &&
                  softScorePairing?.playerId === newPairings[i].player1Id) ||
                (softScorePairing?.byePlayer && !newPairings[i].player1Id)
              ) {
                newPairings[i].player1SoftScores[x] = {
                  ...softScorePairing,
                  softScore: newPairings[i].player1SoftScores[x].softScore
                };
                found = true;
                break;
              } else if (
                (softScorePairing?.playerId &&
                  softScorePairing?.playerId === newPairings[i].player2Id) ||
                (softScorePairing?.byePlayer && !newPairings[i].player2Id)
              ) {
                newPairings[i].player2SoftScores[x] = {
                  ...softScorePairing,
                  softScore: newPairings[i].player2SoftScores[x].softScore
                };
                found = true;
                break;
              }
            }
          }

          if (found) {
            break;
          }
        }
      }
      setPairings(newPairings);
    }
  };

  useEffect(() => {
    return () => clearTimeout(timer);
  }, [timer]);

  // Syncs roundNo and _roundNo after initial load
  useEffect(() => {
    if (roundNo && !_roundNo && !_roundNo !== 0) {
      set_RoundNo(roundNo);
    }
    // eslint-disable-next-line
  }, [roundNo, _roundNo]);

  useEffect(() => {
    const go = async () => {
      setTriggerHandlePairingStatus(false);
      handlePairingStatus("pending_generate", 5);
      setTopCutOptions(null);
      await delay(1000);
      setLoading(false);
    };
    if (triggerHandlePairingStatus) {
      go();
    }
    // eslint-disable-next-line
  }, [triggerHandlePairingStatus]);

  useEffect(() => {
    const check = async () => {
      try {
        if (organize && activeTab !== 1) return;
        if (!organize && activeTab !== 2) return;
        if (event) {
          if (roundNo === null) {
            const resetInitialRound = findGetParameter("round");
            var round =
              resetInitialRound !== undefined &&
              getIntegerFromString(resetInitialRound) > 0 &&
              getIntegerFromString(resetInitialRound) <= getCurrentRound(event)
                ? getIntegerFromString(resetInitialRound)
                : getCurrentRound(event);
            setRoundNo(round);
          }
        }
      } catch (err) {
        postNotification("error", err);
      }
    };
    check();
    // eslint-disable-next-line
  }, [activeTab, event]);

  useEffect(() => {
    const check = async () => {
      try {
        if (roundNo === null) return;
        if (roundNo > 0) {
          if (event) {
            if (
              getCurrentRound(event) === roundNo &&
              event?.roundTimers?.[roundNo]
            ) {
              setTimerData(event.roundTimers[roundNo]);
            }
          }
        }

        // Resets existing pairings
        setPairings(null);
        setSeatedPairings(null);
        setTeamPairings(null);

        setPlayers(null);
        setTeamPlayers(null);

        await handlePairings(roundNo);
      } catch (err) {
        postNotification("error", err);
      }
    };
    check();
    // eslint-disable-next-line
  }, [roundNo]);

  useEffect(() => {
    const check = async () => {
      try {
        if (!refreshPairings) return;
        await handlePairings(roundNo);
      } catch (err) {
        postNotification("error", err);
      }
      setRefreshPairings(false);
    };
    check();
    // eslint-disable-next-line
  }, [refreshPairings]);

  // Handles pairings filtering
  useEffect(() => {
    switch (filterType) {
      case "Submitted":
        setFilteredPairings(
          event?.boardGameEvent
            ? seatedPairings?.filter((pairing) => pairing?.isDone)
            : event?.teamEvent
              ? teamPairings?.filter((pairing) => pairing?.isDone)
              : pairings?.filter((pairing) => pairing?.isDone)
        );
        break;

      case "Unsubmitted":
        setFilteredPairings(
          event?.boardGameEvent
            ? seatedPairings?.filter((pairing) => !pairing?.isDone)
            : event?.teamEvent
              ? teamPairings?.filter((pairing) => !pairing?.isDone)
              : pairings?.filter((pairing) => !pairing?.isDone)
        );
        break;

      case "Teams With Pairings":
        if (teamPairings?.length) {
          setFilteredPairings(
            teamPairings?.filter((pairing) => pairing?.pairings?.length)
          );
        } else {
          setFilteredPairings(null);
        }
        break;

      case "Teams Without Pairings":
        if (teamPairings?.length) {
          setFilteredPairings(
            teamPairings?.filter((pairing) => !pairing?.pairings?.length)
          );
        } else {
          setFilteredPairings(null);
        }
        break;

      default:
        setFilteredPairings(null);
        setFilterType("");
    }

    // eslint-disable-next-line
  }, [filterType, pairings, teamPairings, seatedPairings]);

  return (
    <EventPairingsDefault
      activeTab={activeTab}
      handleTabChange={handleTabChange}
      event={event}
      setEvent={setEvent}
      organize={organize}
      authContext={authContext}
      setResetModalOpen={setResetModalOpen}
      roundNo={roundNo}
      timerData={timerData}
      setTimerData={setTimerData}
      loading={loading}
      subLoading={subLoading}
      setLoading={setLoading}
      setPlayer={setPlayer}
      player={player}
      pairing={pairing}
      pairings={pairings}
      setPairing={setPairing}
      teamPairings={teamPairings}
      setTeamPairing={setTeamPairing}
      setTeamPlayer={setTeamPlayer}
      seatedPairings={seatedPairings}
      setSeatedPairing={setSeatedPairing}
      setPairingPopUp={setPairingPopUp}
      setEndEventModal={setEndEventModal}
      setPairingProgress={setPairingProgress}
      setPairingStatus={setPairingStatus}
      changeRound={changeRound}
      handlePairingStatus={handlePairingStatus}
      optionsAnchorEl={optionsAnchorEl}
      setOptionsAnchorEl={setOptionsAnchorEl}
      setCreatePairingModal={setCreatePairingModal}
      setOptionsAnchorEl2={setOptionsAnchorEl2}
      setOptionsAnchorEl4={setOptionsAnchorEl4}
      setOptionsAnchorEl5={setOptionsAnchorEl5}
      setOptionsAnchorEl6={setOptionsAnchorEl6}
      postSoftScoreSubmit={postSoftScoreSubmit}
      setRoundTimerOptions={setRoundTimerOptions}
      setTopCutOptions={setTopCutOptions}
      setRefreshPairings={setRefreshPairings}
      optionsAnchorEl2={optionsAnchorEl2}
      optionsAnchorEl4={optionsAnchorEl4}
      optionsAnchorEl5={optionsAnchorEl5}
      optionsAnchorEl6={optionsAnchorEl6}
      setArmyModalOpen={setArmyModalOpen}
      setSwapPlayerModal={setSwapPlayerModal}
      teamPairing={teamPairing}
      teamPlayer={teamPlayer}
      seatedPairing={seatedPairing}
      setSwapSeatedPairingModal={setSwapSeatedPairingModal}
      setSwapSeatNumberModal={setSwapSeatNumberModal}
      setSwapTeamModal={setSwapTeamModal}
      pairingPopUp={pairingPopUp}
      setSwapTableModal={setSwapTableModal}
      roundTimerOptions={roundTimerOptions}
      topCutOptions={topCutOptions}
      setTriggerHandlePairingStatus={setTriggerHandlePairingStatus}
      endEventModal={endEventModal}
      armyModalOpen={armyModalOpen}
      swapPlayerModal={swapPlayerModal}
      players={players}
      teamPlayers={teamPlayers}
      swapTeamModal={swapTeamModal}
      swapSeatNumberModal={swapSeatNumberModal}
      swapSeatedPairingModal={swapSeatedPairingModal}
      swapTableModal={swapTableModal}
      pairingProgress={pairingProgress}
      pairingStatus={pairingStatus}
      createPairingModal={createPairingModal}
      filtersAnchorEl={filtersAnchorEl}
      setFiltersAnchorEl={setFiltersAnchorEl}
      filteredPairings={filteredPairings}
      filterType={filterType}
      setFilterType={setFilterType}
      setSubLoading={setSubLoading}
      handleClick={handleClick}
      _roundNo={_roundNo}
      betweenRoundsModal={betweenRoundsModal}
      setBetweenRoundsModal={setBetweenRoundsModal}
    />
  );
}
